export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.051 4.252a.75.75 0 01.691.642l1.519 10.627 2.02-6.736a.75.75 0 011.43-.022l.83 2.487H20a.75.75 0 010 1.5h-4a.75.75 0 01-.711-.513l-.251-.752-2.32 7.73a.75.75 0 01-1.46-.109L9.755 8.588 8.72 12.206A.75.75 0 018 12.75H4a.75.75 0 010-1.5h3.434L9.28 4.794a.75.75 0 01.772-.542z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};